module.exports = __webpack_public_path__ + "static/media/Плотникова Анна РУБ 2017 Что я сделаю для людей-4.png";